import React from 'react';
import {AvForm} from 'availity-reactstrap-validation';
import ProductPriceColumn from "../../shared/component/dataTable/columns/ProductPriceColumn.json";
import {Fieldset} from "primereact/fieldset";
import ProductService from "../../shared/service/ProductService";
import GeneralUtils from "../../shared/utils/GeneralUtils";
import Dialog from "../../shared/component/dialog/Dialog";
import DataTable from "../../shared/component/dataTable/DataTable";
import {Button, Col, Row} from "reactstrap";
import {InputText} from "primereact/inputtext";
import DepartmentFilter from "../storemanagement/DepartmentFilter";
import ProductPriceSave from "./ProductPriceSave";

export default class ProductPriceList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {}
        this.productService = new ProductService();
    }

    componentDidMount() {
        this.refresh();
    }

    renderFilter() {
        return (<div><Row>
            <Col md="6">


            <span className="p-input-icon-right">
                <InputText style={{borderRadius: "10px", width: "240px"}} disabled value={this.state.departmentName}
                           placeholder="Select Department"
                           onClick={() => this.setState({displayDialogFilter: true})}/>
                <i
                    className="pi pi-search"
                    style={{cursor: "pointer"}}
                    onClick={() => this.setState({displayDialogFilter: true})}
                />

                <i
                    className="pi pi-times"
                    style={{cursor: "pointer"}}
                    onClick={() => {
                        this.setState({departmentId: null, departmentName: ''})

                    }}
                />

                <i
                    className="pi pi-refresh"
                    style={{cursor: "pointer"}}
                    onClick={() => {
                        this.refDataTable.dt.filter(this.state.departmentId, "department.id", "equals");
                        let filterElement = this.refDataTable.state.filterElement;
                        this.refDataTable.setState({filterElement: filterElement});
                        this.refDataTable.onModelFilterChangeWithNameAndValue("department.id", this.state.departmentId, "long");

                    }}
                />



            </span>
            </Col>


            <Col>
                <Dialog visible={this.state.displayDialogFilter}
                        header={"Department"}
                        onHide={() => this.setState({displayDialogFilter: false})}
                        style={{width: '30vw', height: '35vw'}}>

                    <DepartmentFilter
                        ref={(elem) => this.refModelCredentialsSave = elem}
                        onDataSelect={this.onDataSelectFilter}
                        closeDisplayDialog={this.closeDisplayDialogFilter}/>
                </Dialog>
            </Col>

        </Row>

        </div>)
    }


    refresh() {
        this.refDataTable.refresh();
    }

    render() {
        return (<div>
            <AvForm>
                {this.renderFilter()}
                {this.productList()}
            </AvForm>
        </div>);
    }

    productList() {

        var url = "product/product/all";

        return (<div>
            <Fieldset legend="Product Price List">
                <Dialog visible={this.state.displayDialog}
                        header={""}
                        onHide={() => this.setState({displayDialog: false})}
                        style={GeneralUtils.getDialogStyleForProduct()}>

                    <ProductPriceSave ref={(elem) => this.refModelSave = elem}
                                      refreshDataTable={this.refreshDataTable}
                                      closeDisplayDialog={this.closeDisplayDialog}/>
                </Dialog>


                {GeneralUtils.checkPrivilege("put_product/product/all") &&
                    <DataTable ref={(elem) => this.refDataTable = elem} fields={ProductPriceColumn.fields}
                               objectName={ProductPriceColumn.name}
                               dataURL={url}
                               selectionMode="single" onDataSelect={this.onDataSelect}
                               loading={this.state.loading}/>
                }
            </Fieldset>


        </div>)
    };

    onDataSelect = (data) => {
        this.refModelSave.setData(data);
        this.setState({displayDialog: true});
    }


    closeDisplayDialog = () => {
        this.setState({displayDialog: false});
    }

    refreshDataTable = () => {
        this.closeDisplayDialog();
        this.refDataTable.refresh();
    }
    closeDisplayDialogFilter = () => {
        this.setState({displayDialogFilter: false});
    }

    onDataSelectFilter = (data) => {
        this.setState({departmentId: data.id});
        this.setState({departmentName: data.name});
        this.setState({displayDialogFilter: false});
    }

}

